module.exports = __webpack_public_path__ + "img/so-do-ben-xe-123.fb7fb079.jpg";